import { defineStore } from "pinia";

const SESSION_KEY = "pdfViewerFetchParams";

export interface PdfFetchParams {
    trainer: string;
    product: string;
    participantId: number;
    language: string;
}

function loadFetchParams(): PdfFetchParams | null {
    try {
        const raw = sessionStorage.getItem(SESSION_KEY);
        return raw ? (JSON.parse(raw) as PdfFetchParams) : null;
    } catch {
        return null;
    }
}

export const usePdfViewerStore = defineStore("pdfViewer", {
    state: () => ({
        blob: null as Blob | null,
        filename: "",
        returnRoute: "/projects",
        fetchParams: loadFetchParams(),
    }),
    actions: {
        open(blob: Blob, filename: string, returnRoute = "/projects", fetchParams?: PdfFetchParams) {
            this.blob = blob;
            this.filename = filename;
            this.returnRoute = returnRoute;
            if (fetchParams) {
                this.fetchParams = fetchParams;
                sessionStorage.setItem(SESSION_KEY, JSON.stringify(fetchParams));
            }
        },
        clear() {
            this.blob = null;
            this.filename = "";
            this.fetchParams = null;
            sessionStorage.removeItem(SESSION_KEY);
        },
    },
});
